import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'
import { AccessibleGoogleAccount } from 'honeygrid-types'
import { toast } from 'sonner'

export const googleAdsAccountsQueryKey = 'googleAdsAccounts'

interface GoogleAdsAccountsParams {
	workspaceId?: string
	connectionId: string
}

export const useGoogleAdsAccounts = ({
	workspaceId = '',
	connectionId,
}: GoogleAdsAccountsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<{ accounts: AccessibleGoogleAccount[] }>({
		queryKey: [googleAdsAccountsQueryKey, workspaceId, connectionId],
		queryFn: async () => {
			if (!workspaceId) {
				toast.error('Workspace ID is required')
				throw new Error('Workspace ID is required')
			}
			return authFetch(`workspaces/${workspaceId}/connections/${connectionId}/accounts`)
		},
		enabled: !!connectionId && !!workspaceId,
	})
}
